import { render, staticRenderFns } from "./Confsetting.vue?vue&type=template&id=23d992ca&scoped=true&"
import script from "./Confsetting.vue?vue&type=script&lang=ts&"
export * from "./Confsetting.vue?vue&type=script&lang=ts&"
import style0 from "./Confsetting.vue?vue&type=style&index=0&id=23d992ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d992ca",
  null
  
)

export default component.exports